<template>
  <div class="inspection-due-date-panel">
    <div class="inspection-due-date-label-and-date">
      <div class="inspection-due-date-label">
        {{ t('documentDetailView.inspectionDueDate') }}:
      </div>

      <div class="inspection-due-date">{{ transformInspectionDueDate() }}</div>
    </div>

    <vf-button
      v-if="isUserRole([Role.Admin, Role.DocuManager, Role.Inspector])"
      @click="showModal()"
      >{{ t('documentDetailView.changeInspectionDueDate') }}</vf-button
    >

    <change-inspection-due-date-modal
      ref="modalRef"
      :file-ids="[fileId]"
      :project-id="projectId"
      @inspection-due-dates-updated="handleInspectionDueDateUpdated"
    ></change-inspection-due-date-modal>
  </div>
</template>

<script lang="ts" setup>
  import { formatDateForDisplay } from '@/helpers/formatDateForDisplay';
  import { useI18n } from 'vue-i18n';
  import VfButton from '@/components/VfButton/VfButton.vue';
  import ChangeInspectionDueDateModal from '@/components/ChangeInspectionDueDateModal/ChangeInspectionDueDateModal.vue';
  import { ref } from 'vue';
  import { useRoles } from '@/composables/useRoles';
  import { Role } from 'types';

  const { t } = useI18n();
  const { isUserRole } = useRoles();

  const props = defineProps<{
    fileId: string;
    projectId: string;
    inspectionDueDate: string;
  }>();

  const emit = defineEmits<{
    (e: 'inspection-due-date-updated'): void;
  }>();

  function transformInspectionDueDate(): string {
    return formatDateForDisplay(new Date(props.inspectionDueDate));
  }

  const modalRef = ref<InstanceType<typeof ChangeInspectionDueDateModal>>();
  function showModal() {
    modalRef.value?.show();
  }
  function handleInspectionDueDateUpdated() {
    emit('inspection-due-date-updated');
    modalRef.value?.hide();
  }
</script>

<style lang="scss">
  .inspection-due-date-panel {
    width: 100%;
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 1.25rem;

    .inspection-due-date-label-and-date {
      display: flex;
      column-gap: 20px;
    }
  }
</style>
